import { vProductoModel } from './vProducto.model';

export class MensajeProductoModel
{
	constructor() { }

	public IdMensajeProducto: number = 0;
	public IdMensaje: number = 0;
	public Cantidad: number = 0;
	public IdProducto: number = 0;

	public vProductos: vProductoModel = null;
}